/* Bốn góc nhìn của màn Khách tiềm năng theo người dùng */
import { ClipboardList, Headset, MessagesSquare, Store, type LucideIcon } from 'lucide-react';

export type Role = 'ops' | 'page' | 'tele' | 'branch';

export const ROLES: Role[] = ['ops', 'page', 'tele', 'branch'];

export const ROLE_META: Record<Role, { label: string; hint: string; icon: LucideIcon }> = {
  ops: { label: 'Người vận hành', hint: 'Theo dõi hạn xử lý của cả phòng, phân công lại khách cho Telesales', icon: ClipboardList },
  page: { label: 'Trực page', hint: 'Tạo khách từ chat, theo dõi Telesales đã xử lý khách mình tạo chưa', icon: MessagesSquare },
  tele: { label: 'Telesales', hint: 'Toàn bộ khách được giao cho tôi — gọi theo hàng đợi ở Tổng đài Sales', icon: Headset },
  branch: { label: 'Sale cơ sở', hint: 'Khách Telesales hẹn đến cơ sở: check-in, tư vấn, ghi kết quả', icon: Store },
};

/** Phòng ban nhân viên (type_department_id): 2 Trực page · 3 Telesale · 4 Sale cơ sở */
const DEPT_ROLE: Record<number, Role> = { 2: 'page', 3: 'tele', 4: 'branch' };

export interface Me { staffId: number | null; name: string; role: Role | null }

/**
 * Người đang đăng nhập. Tài khoản nhân viên thì user.info chính là bản ghi staff (id staff = info.id);
 * tài khoản admin thì info là bản ghi user → chỉ tin info.staff_id.
 */
export const currentMe = (): Me => {
  try {
    const u = JSON.parse(localStorage.getItem('user') || '{}');
    // Ngay sau đăng nhập user còn ở dạng phẳng, chưa có .info cho tới khi đồng bộ profile
    const info = u?.info ?? u ?? {};
    const isUser = Number(u?.type ?? info?.type ?? 0) === 1;
    const staffId = Number(isUser ? info?.staff_id : info?.staff_id ?? info?.id) || null;
    const dept = Number(info?.type_department_id ?? info?.department?.type_department_id ?? 0);
    return { staffId, name: info?.fullname || info?.name || 'Tôi', role: DEPT_ROLE[dept] ?? null };
  } catch {
    return { staffId: null, name: 'Tôi', role: null };
  }
};
